import { createSubject, SceneGestures } from '../support';
import { $atom, $value, $ref } from '@graphistry/falcor-json-graph';
import { SCENE_TOUCH_START } from '@graphistry/viz/src/actions/scene';

export function drawNodeSelection(actions) {

    const drawMaskStarts = SceneGestures.startFromActions(
        actions
            .ofType(SCENE_TOUCH_START)
            .filter(({ simulating, selectionType }) => !simulating && selectionType === 'select')
    );

    const startsWithShiftOrAltKey = SceneGestures.startFromActions(
      actions
        .ofType(SCENE_TOUCH_START)
        .filter(
          ({ event, simulating, selectionType }) =>
            !simulating &&
            !event.button &&
            !selectionType &&
            (event.getModifierState("Alt") || event.getModifierState("Shift"))
        )
    );

    const drawStarts = drawMaskStarts
        .merge(startsWithShiftOrAltKey).take(1)

    const drawnNodeSelections = SceneGestures
        .pan(drawStarts)
        .switchMap((drag) => drag
            .dragRectInWorldCoords()
            .multicast(createSubject, (drag) =>
                drag.merge(new SceneGestures(drag.takeLast(1)).withModifiedSelection()))
        ).repeat();

    return drawnNodeSelections.map(toValuesAndInvalidations);
}

export function toValuesAndInvalidations({ rect, falcor, modifiedSelection, ...props }) {
    let values;
    if (!modifiedSelection) {
        values = [
            $value(`selection.type`, 'select'),
            $value(`selection.mask`, $atom(rect)),
            $value(`selection.cursor`, 'down')
        ];
    } else {
        values = [
            {
                json: {
                    highlight: {
                        edge: $atom([]),
                        point: $atom([])
                    },
                    selection: {
                        mask: null,
                        type: null,
                        cursor: 'auto',
                        edge: $atom(modifiedSelection.edges),
                        point: $atom(modifiedSelection.points),
                        controls: { 0: { selected: false } }
                    },
                    ...(modifiedSelection.points.length === 1 ? {
                        labels: {
                            selection: $ref(falcor.getPath().concat("labelsByType", 'point', modifiedSelection.points[0])),
                          },
                    } : {})
                }
            }
        ];
    }
    return { falcor, values };
}
